import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Section, SectionHeading } from "@/components/layout/Section";
import { MicroLabel } from "@/components/common/MicroLabel";
import { Reveal } from "@/components/common/Reveal";
import { APPLICATIONS } from "@/content/homeContent";

/**
 * Applications — editorial/typographic system (no illustrations).
 * Each card: large index, technical micro-label, title, description, link.
 */
export const Applications = () => {
  return (
    <Section id="applications-section" tone="light">
      <Reveal>
        <SectionHeading
          microLabel="APPLICAZIONI REALI"
          title="Cosa puoi produrre con Strato."
          description="Non un catalogo: categorie di lavorazioni tipiche, adattate al tuo caso d'uso."
        />
      </Reveal>

      <div className="mt-12 grid grid-cols-1 gap-px overflow-hidden rounded-2xl border border-strato-gray-100 bg-strato-gray-100 sm:grid-cols-2 lg:grid-cols-3">
        {APPLICATIONS.map((app, i) => (
          <Reveal key={app.id} delay={i * 0.05}>
            <div
              data-testid={`application-${app.id}`}
              className="group flex h-full flex-col bg-strato-white p-7 transition-colors duration-150 hover:bg-strato-offwhite sm:p-8"
            >
              <div className="flex items-baseline justify-between">
                <span className="font-display text-4xl font-medium tabular-nums tracking-[-0.02em] text-strato-gray-200 transition-colors duration-150 group-hover:text-strato-blue">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <MicroLabel className="text-strato-gray-300">{app.meta}</MicroLabel>
              </div>

              <h3 className="mt-6 font-display text-xl font-medium tracking-[-0.01em] text-strato-graphite">
                {app.title}
              </h3>
              <p className="mt-2 flex-1 text-sm leading-[1.6] text-muted-foreground">
                {app.description}
              </p>
              <Link
                to={app.to || "/preventivo"}
                data-testid={`application-cta-${app.id}`}
                className="mt-6 inline-flex items-center gap-1.5 text-sm font-medium text-strato-blue transition-colors hover:text-strato-blue-hover"
              >
                Scopri il servizio
                <ArrowUpRight className="h-4 w-4 transition-transform duration-150 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </Link>
            </div>
          </Reveal>
        ))}
      </div>
    </Section>
  );
};
